import React from 'react';

export type AdminTenantOption = {
  tenantId: string;
  displayName: string;
  isBillingTenant: boolean;
  isSessionTenant: boolean;
  sharePointHost?: string;
};

type AdminTenantSelectorProps = {
  value: string;
  options: AdminTenantOption[];
  onChange: (tenantId: string) => void;
  label?: string;
  disabled?: boolean;
  helperText?: string;
};

const AdminTenantSelector = ({
  value,
  options,
  onChange,
  label = 'Tenant',
  disabled,
  helperText
}: AdminTenantSelectorProps): JSX.Element => {
  const selected = options.find((entry) => entry.tenantId === value) ?? options[0] ?? null;

  return (
    <label>
      <div className="muted" style={{ marginBottom: '4px' }}>{label}</div>
      {options.length <= 1 && selected ? (
        <div style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '10px 12px', background: '#f8fafc' }}>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
            <strong>{selected.displayName}</strong>
            {selected.sharePointHost && <span className="badge-subtle">{selected.sharePointHost}</span>}
            {selected.isBillingTenant && <span className="badge-subtle">Billing tenant</span>}
            {selected.isSessionTenant && <span className="badge-subtle">Signed-in tenant</span>}
          </div>
        </div>
      ) : (
        <select
          className="input"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          disabled={disabled}
        >
          {options.map((entry) => (
            <option key={entry.tenantId} value={entry.tenantId}>
              {entry.displayName}
              {entry.sharePointHost ? ` (${entry.sharePointHost})` : ''}
              {entry.isBillingTenant ? ' [billing]' : ''}
              {entry.isSessionTenant ? ' [signed-in]' : ''}
            </option>
          ))}
        </select>
      )}
      {helperText && <div className="muted" style={{ marginTop: '6px' }}>{helperText}</div>}
    </label>
  );
};

export default AdminTenantSelector;
